<template>
  <loan-list
    filter="Purchasing"
    :title="$t('menu.purchasingLoan')"
  />
</template>

<script>
import LoanList from './List'

export default {
  name: 'PurchasingLoanList',
  metaInfo () {
    return {
      title: this.$t('menu.purchasingLoan'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  components: { LoanList }
}
</script>

<style scoped>

</style>
